import { render, staticRenderFns } from "./Notificator.vue?vue&type=template&id=17e2a7b8&scoped=true&"
import script from "./Notificator.vue?vue&type=script&lang=js&"
export * from "./Notificator.vue?vue&type=script&lang=js&"
import style0 from "./Notificator.vue?vue&type=style&index=0&id=17e2a7b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e2a7b8",
  null
  
)

export default component.exports